import currentPosition from './currentPosition';
import formType from './formType';
import initialPosition from './initialPosition';
import pointsOfInterest from './pointsOfInterest';
import areasOfInterest from './areasOfInterest';
import perimetersAttention from './perimetersAttention';

const rootReducer = {
    currentPosition,
    formType,
    initialPosition,
    pointsOfInterest,
    areasOfInterest,
    perimetersAttention,
};

export default rootReducer;
